import script from "./DocsScrollAnchor.vue?vue&type=script&setup=true&lang=js"
export * from "./DocsScrollAnchor.vue?vue&type=script&setup=true&lang=js"

import "./DocsScrollAnchor.vue?vue&type=style&index=0&id=c2a54494&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2a54494"]])

export default __exports__